<template>
    <div>
        <div
            v-if="appointment"
            v-show="!showEdit"
        >
            <dl class="kgr-definitionList kgr-definitionList--horizontal kgr-definitionList--150"
                v-if="appointment.appointmentOverride"
            >
                <dt
                    v-if="appointment.appointmentOverride.title"
                    class="kgr-definitionList__term"
                >
                    {{ $t('Abweichender Titel') }}:
                </dt>
                <dd
                    v-if="appointment.appointmentOverride.title"
                    class="kgr-definitionList__definition"
                >
                    {{ appointment.appointmentOverride.title }}
                </dd>
                <dt
                    v-if="appointment.appointmentOverride.note"
                    class="kgr-definitionList__term"
                >
                    {{ $t('Zusätzlicher Hinweis') }}:
                </dt>
                <dd
                    v-if="appointment.appointmentOverride.note"
                    class="kgr-definitionList__definition"
                >
                    {{ appointment.appointmentOverride.note }}
                </dd>
                <dt
                    v-if="appointment.appointmentOverride.instructors.length > 0"
                    class="kgr-definitionList__term"
                >
                    {{ $t('Abweichender Trainer') }}:
                </dt>
                <dd
                    v-if="appointment.appointmentOverride.instructors.length > 0"
                    class="kgr-definitionList__definition"
                >
                    {{ appointmentOverrideInstructorNames }}
                </dd>
                <dt
                    v-if="appointment.appointmentOverride.fields.length > 0"
                    class="kgr-definitionList__term"
                >
                    {{ $t('Abweichender Ort') }}:
                </dt>
                <dd
                    v-if="appointment.appointmentOverride.fields.length > 0"
                    class="kgr-definitionList__definition"
                >
                    {{ appointmentOverrideFieldNames }}
                </dd>
            </dl>
        </div>
        <div
            v-if="showEdit"
            class="kgr-row"
        >
            <kgr-form-row
                :label="$t('Abweichender Titel')"
                :error="error"
                field-name="title"
            >
                <input
                    v-model.trim="appointment.appointmentOverride.title"
                    type="text"
                    class="kgr-input"
                />
            </kgr-form-row>
            <kgr-form-row
                :label="$t('Zusätzlicher Hinweis')"
                :error="error"
                field-name="note"
            >
                <input
                    v-model.trim="appointment.appointmentOverride.note"
                    type="text"
                    class="kgr-input"
                />
            </kgr-form-row>
            <kgr-form-row
                :label="$t('offering.instructors')"
                :error="error"
                field-name="instructors"
            >
                <kgr-multi-select
                    v-model="appointment.appointmentOverride.instructors"
                    :options="filteredInstructors(appointment.appointmentOverride ? appointment.appointmentOverride.instructors : [])"
                    :multiple="true"
                    mode="tags"
                />
            </kgr-form-row>
            <kgr-form-row
                :label="$t('offering.locations')"
                :error="error"
                field-name="selectedLocation"
            >
                <kgr-searchable-dropdown
                    v-model="selectedLocation"
                    :options="locations"
                    display="name"
                    @post-input="updateAreas"
                />
            </kgr-form-row>
            <kgr-form-row
                :label="$t('offering.areas')"
                :error="error"
                field-name="selectedArea"
            >
                <kgr-searchable-dropdown
                    v-model="selectedArea"
                    :options="areas"
                    display="name"
                    @post-input="updateFields"
                />
            </kgr-form-row>
            <kgr-form-row
                :label="$t('offering.fields')"
                :error="error"
                field-name="selectedFields"
            >
                <kgr-multi-select
                    v-model="appointment.appointmentOverride.fields"
                    :options="filteredFieldList"
                    :inline="false"
                    searchable
                />
            </kgr-form-row>
            <br />
            <div class="kgr-row">
                <button
                    class="kgr-button"
                    @click="onCancelEdit"
                >
                    {{ $t('Abbrechen') }}
                </button>
                <button
                    class="kgr-button kgr-button--accent"
                    @click="saveOverride"
                >
                    {{ $t('Speichern') }}
                </button>
            </div>
        </div>
        <kgr-update-offering-with-notification-modal
            :show-dialog="showConfirmModal"
            :headline="$t('Soll dieser Termin geändert werden?')"
            @confirm="onSaveConfirm"
            @cancel="onCancel"
        />
    </div>
</template>

<script>
import AppointmentRepository from '../../../js/repository/AppointmentRepository';
import Error from '../../../js/model/Error.js';
import FormRow from '../../common/form/FormRow.vue';
import LocationRepository from '../../../js/repository/LocationRepository';
import MultiSelect from '../../common/form/select/MultiSelect.vue';
import OfferingAppointment from '../../../js/dto/offering/OfferingAppointment';
import SearchableDropdown from '../../common/form/select/SearchableDropdown.vue';
import UpdateOfferingWithNotificationModal from '../UpdateOfferingWithNotificationModal.vue';

export default {
    name: 'KgrAppointmentChanges',
    components: {
        'kgr-form-row': FormRow,
        'kgr-multi-select': MultiSelect,
        'kgr-searchable-dropdown': SearchableDropdown,
        'kgr-update-offering-with-notification-modal': UpdateOfferingWithNotificationModal,
    },
    props: {
        appointmentProp: {
            type: OfferingAppointment,
            required: true,
        },
        showEdit: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: Error,
            required: true,
        },
        instructors: {
            type: Array,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data () {
        return {
            value: 0,
            appointment: null,
            locations: [],
            locationsFullArray: [],
            selectedLocation: '',
            areas: [],
            selectedArea: '',
            areaFullArray: [],
            fieldList: [],
            showConfirmModal: false,
        }
    },
    mounted () {
        this.appointment = this.appointmentProp;
        this.loadLocations().then(result => {
            this.locations.length = 0;
            this.locations.push(...result)
        });
    },
    computed: {
        appointmentOverrideInstructorNames() {
            if(!this.appointment.appointmentOverride) {
                return ''
            }
            if (this.appointment.appointmentOverride.instructors.length === 0) {
                return '-';
            }
            return this.appointment.appointmentOverride.instructors.map(instructor => instructor.label).join(', ');
        },
        appointmentOverrideFieldNames() {
            if(!this.appointment.appointmentOverride) {
                return ''
            }
            if (this.appointment.appointmentOverride.fields.length === 0) {
                return '-';
            }
            return this.appointment.appointmentOverride.fields.map(field => field.label).join(', ');
        },
        filteredFieldList() {
            return this.fieldList.filter(field => {
                return this.appointment.appointmentOverride.fields.find(selectedField => selectedField.value === field.value) === undefined
            });
        },
    },
    methods: {
        saveOverride() {
            this.showConfirmModal = true;
        },
        onSaveConfirm(payload) {
            this.showConfirmModal = false;
            this.updateOverride(payload.notifyParticipants, payload.notifyClubEmployees);
        },
        onCancel() {
            this.showConfirmModal = false;
        },
        onCancelEdit() {
            this.$emit('cancelEdit');
        },
        updateOverride(notifyParticipants, notifyClubEmployees) {
            AppointmentRepository.update(this.appointment, notifyParticipants, notifyClubEmployees)
                .then(() => {
                    this.$notify.success('Die Abweichung wurde erfolgreich gespeichert')
                    this.$emit('updateAppointment', this.appointment);
                })
                .catch(() => this.$notify.error('Die Abweichung konnte nicht gespeichert werden'));
        },
        filteredInstructors(appointmentInstructors) {
            return this.instructors.filter(instructor => {
                return appointmentInstructors.find(selectedInstructor => selectedInstructor.value === instructor.value) === undefined
            });
        },
        updateAreas() {
            this.areas = [];
            this.areaFullArray = [];
            if (this.locationsFullArray) {
                this.locationsFullArray.forEach(location => {
                    if (this.selectedLocation !== null && location.id === this.selectedLocation.value) {
                        location.areas.forEach(area => {
                            if (!area.isArchived) {
                                this.areas.push({
                                    'name': area.hierarchyPath + ' / ' + area.name,
                                    'value': area.id
                                });
                            }
                            this.areaFullArray.push(area);
                        })
                    }
                });
            }
        },
        updateFields() {
            this.fieldList = [];
            if (this.areaFullArray) {
                this.areaFullArray.forEach(area => {
                    if (this.selectedArea !== null && area.id === this.selectedArea.value) {
                        area.fields.forEach(field => {
                            if (!field.isArchived) {
                                this.fieldList.push({
                                    'label': field.hierarchyPath + ' / ' + field.name,
                                    'value': field.id
                                });
                            }
                        })
                    }
                });
            }
        },
        loadLocations() {
            return LocationRepository.findAllByClubId(this.clubId)
                .then(locations => {
                    const result = [];
                    locations.forEach(location => {
                        if (!location.isArchived) {
                            result.push({
                                'name': location.name,
                                'value': location.id
                            });
                        }
                    });
                    this.locationsFullArray = locations;
                    return result;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
    }
}
</script>
